module.exports = __webpack_public_path__ + "8c15ae0986bcb1d74a0f1f526e731869.pdf";